import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AssignStationModel, StationRequestModel } from "@tsin-core/states/station/station.model";
import { environment } from "@tsin-env/environment";
import { Observable, catchError, throwError } from "rxjs";

const BASE_URL = `${environment.apiUrl2}`;
const BASE_URL_2 = `${environment.apiUrl2}`;

@Injectable({
  providedIn: 'root'
})

export class StationService {

  http: HttpClient = inject(HttpClient);

  getStations(): Observable<StationRequestModel[]> {
    return this.http.get<StationRequestModel[]>(`${BASE_URL}/station`).pipe(
      catchError(error => {
        console.error('Error fetching stations:', error);
        return throwError(() => error);
      })
    );
  }
  getStation(id: string): Observable<StationRequestModel> {
    return this.http.get<StationRequestModel>(`${BASE_URL}/station/single/${id}`).pipe(
      catchError(error => {
        console.error('Error fetching stations:', error);
        return throwError(() => error);
      })
    );
  }

  getStationsByTrack(trackId: string): Observable<StationRequestModel[]> {
    return this.http.get<StationRequestModel[]>(`${BASE_URL}/station/track/${trackId}`).pipe(
      catchError(error => {
        console.error('Error fetching stations by track:', error);
        return throwError(() => error);
      })
    );
  }

  getStationSchedule(stationId: string): Observable<any[]> {
    return this.http.get<any[]>(`${BASE_URL_2}/schedules/station/${stationId}`).pipe(
      catchError(error => {
        console.error('Error fetching station schedule:', error);
        return throwError(() => error);
      })
    );
  }

  createStation(formData: Omit<StationRequestModel, 'id'>): Observable<StationRequestModel> {
    return this.http.post<StationRequestModel>(`${BASE_URL}/station`, formData).pipe(
      catchError(error => {
        console.error('Error fetching stations:', error);
        return throwError(() => error);
      })
    );
  }

  updateStation(formData: StationRequestModel): Observable<StationRequestModel> {
    return this.http.put<StationRequestModel>(`${BASE_URL}/station`, formData).pipe(
      catchError(error => {
        console.error('Error fetching stations:', error);
        return throwError(() => error);
      })
    );
  }

  deleteStation(id: string): Observable<StationRequestModel> {
    return this.http.delete<StationRequestModel>(`${BASE_URL}/station/single/${id}`).pipe(
      catchError(error => {
        console.error('Error fetching tracks:', error);
        return throwError(() => error);
      })
    );
  }

  assignStation(data: any): Observable<AssignStationModel> {
    return this.http.patch<AssignStationModel>(`${BASE_URL_2}/schedules/generate-schedule/${data.cohortId}`, {}).pipe(
      catchError(error => {
        console.error('Error fetching tracks:', error);
        return throwError(() => error);
      })
    );
  }

  getRotations(cohortId: string): Observable<any> {
    return this.http.get<any>(`${BASE_URL}/schedules/rotation-interviewers/${cohortId}`).pipe(
      catchError(error => {
        console.error('Error fetching tracks:', error);
        return throwError(() => error);
      })
    );
  }

  getActivityHistory(payload: { trackId: string, stationId: string, scheduleId: string, cohortId: string, }): Observable<any[]> {
    return this.http.get<any[]>(`${BASE_URL}/activities`, {
      params: {
        trackId: payload.trackId,
        stationId: payload.stationId,
        scheduleId: payload.scheduleId,
        cohortId: payload.cohortId
      }
    }).pipe(
      catchError(error => {
        console.error('Error fetching activites:', error);
        return throwError(() => error);
      })
    );
  }

}
